<template>
  <div class="question-container" style="border: 1px solid #edeff2">
    <div class="question-type">音频</div>

    <div class="title-view" :style="{ marginRight: '' }">
      <!-- <p style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
        </span>
      </p> -->

      <p class="question-row">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        <span class="index">{{
          `${dataObj.questionIndex || index + 1}、`
        }}</span>

        <!-- 富文本 + 后缀文字 放在同一个容器里 -->
        <span class="rich-text-wrapper">
          <span class="rich-text-content" v-html="dataObj.caseProblem"></span>
        </span>
      </p>
    </div>

    <div class="question-images">
      <div
        v-for="(item, idx) in images"
        :key="idx"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" style="width: 100%" />
      </div>
    </div>

    <div
      v-for="(audioItem, audioIndex) in fileList"
      :key="audioIndex"
      class="music-view"
      @click="handleAudioPlay(index, audioIndex)"
    >
      <AudioItem
        :styleType="'2'"
        :key="audioIndex"
        :title="audioItem.name"
        :src="audioItem.url"
        :playing-id="playingId"
        :time="audioItem.time"
        :param="[index, null]"
        :progress-width="progressWidth"
        :showDel="false"
        @play="onPlay"
      />
    </div>
  </div>
</template>

<script>
import AudioItem from "@/components/AudioItem/index.vue";

export default {
  components: {
    AudioItem,
  },
  props: {
    params: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dataObj: {},
      index: 0,
      images: [],
      fileList: [],
      currentAudio: null,
      audioContext: null, // 音频上下文
      playingId: "",
      progressWidth: 370,
    };
  },
  mounted() {
    this.audioContext = new Audio();
  },
  beforeDestroy() {
    // 销毁音频上下文
    if (this.audioContext) {
      this.audioContext.pause();
      this.audioContext = null;
    }
  },
  methods: {
    // // 音频播放/暂停
    // handleAudioPlay(index, audioIndex) {
    //   const audioUrl = this.fileList[index].url;

    //   // 检查是否是当前正在播放的音频
    //   if (
    //     this.currentAudio &&
    //     this.currentAudio.index === index &&
    //     !this.audioContext.paused
    //   ) {
    //     // 暂停当前音频
    //     this.audioContext.pause();
    //     this.currentAudio = null;
    //   } else {
    //     // 停止当前音频（如果有）
    //     if (!this.audioContext.paused) {
    //       this.audioContext.pause();
    //     }
    //     // 播放新音频
    //     this.audioContext.src = audioUrl;
    //     this.audioContext.play();
    //     // 记录当前播放的音频信息
    //     this.currentAudio = {
    //       index: index,
    //       audioIndex: audioIndex,
    //       url: audioUrl,
    //     };
    //   }
    // },
    // // 秒转时分秒
    // secondsToHms(seconds) {
    //   const hours = Math.floor(seconds / 3600);
    //   const minutes = Math.floor((seconds % 3600) / 60);
    //   const secs = seconds % 60;
    //   return [hours, minutes, secs]
    //     .map((v) => (v < 10 ? `0${v}` : v))
    //     .join(":");
    // },
    onPlay(id) {
      this.playingId = id;
    },
  },
  watch: {
    params: {
      handler(newVal) {
        if (!newVal) return;
        this.dataObj = newVal.data || {};
        this.index = newVal.index || 0;

        try {
          this.images = JSON.parse(this.dataObj.caseProblemImg || "[]");
        } catch (e) {
          this.images = [];
        }

        try {
          const chooseList = JSON.parse(
            this.dataObj.chooseList || '{"list": []}',
          );
          this.fileList = chooseList.list || [];
        } catch (e) {
          this.fileList = [];
        }

        console.log("newVal.progressWidth", newVal.progressWidth);
        this.progressWidth = newVal.progressWidth || 370;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.file-item {
  margin-top: 8px;
}

.file-link {
  color: #3a60ff;
  text-decoration: underline;
  cursor: pointer;
}

.upload-file {
  margin: 10px 0;
}

.upload-file .file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.upload-file .file-item .filename {
  max-width: 80%;
  display: flex;
  align-items: center;
  gap: 8.5px;
}

.upload-file .file-item .filename .icon {
  width: 24px;
  height: 21px;
  flex: none;
}
.upload-file .file-item .filename span {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  color: #333;
}

.upload-file .file-item + .file-item {
  margin-top: 5px;
}

.upload-file .file-item .down {
  width: 59px;
  height: 31.5px;
  background: #3a60ff;
  border-radius: 5px;
  font-size: 13px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5.5px;
  cursor: pointer;
}

.upload-file .file-item .down img {
  width: 10px;
  height: 12px;
}

.music-view {
  width: 100%;
  height: 38.5px;
  background: #ffffff;
  /* border: 1px solid #eeeeee; */
  border-radius: 19.25px;
  display: flex;
  align-items: center;
  margin-top: 10px;
  position: relative;
  cursor: pointer;
}

.music-image {
  width: 16px;
  height: 20px;
  margin-left: 10.5px;
}

.music-time {
  font-size: 15px;
  font-weight: 600;
  color: #656374;
  margin-left: 14.5px;
}
</style>



// WEBPACK FOOTER //
// src/components/EvaluationPreview/EvaluationPreviewAudio.vue